/** Reactions players can throw at each other mid-match. */
export const EMOJI_SET = ['😂', '😮', '😎', '😭', '🔥', '👏', '🤔', '❤️', '😡', '🤝'];
export function isEmojiReaction(value) {
    return EMOJI_SET.includes(value);
}
//# sourceMappingURL=types.js.map